// import { DetailSupportFormEntrepreneurComponent } from "../../../components/SupportSystem/SupportForm/DetailSupportFormEntrepreneurComponent";
import { DetailInnovationPersonTrainAndExpectedComponent } from "../../../components/SupportSystem/SupportForm/current/DetailInnovationPersonTrainAndExpectedComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function DetailInnovationPersonTrainAndExpectedContainer() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailInnovationPersonTrainAndExpectedComponent/>
            <Footer />
        </div>   
        // 
    )
    
}